export default defineNuxtPlugin(({$config}) => {

    //console.log('API BASEURL:', $config.public.apiBaseUrl)

    const api = $fetch.create({
        baseURL: $config.public.apiBaseUrl,
    })

    return {
        provide: {
            api
        }
    }
})


